var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showFAQ,
          expression: "showFAQ",
        },
      ],
      staticClass: "chatbot-container",
    },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "full chatbot-loading-mask",
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chatbot-body" },
        [
          _c(
            "span",
            {
              staticClass: "close-btn",
              on: {
                click: function ($event) {
                  return _vm.toggleFAQ(false)
                },
              },
            },
            [_c("i", { staticClass: "isif isif-close" })]
          ),
          _vm._v(" "),
          _vm._l(_vm.data, function (item, index) {
            return [
              _c(
                "button",
                {
                  key: item.id,
                  on: {
                    click: function ($event) {
                      return _vm.sendQuestionHandler(item, index)
                    },
                  },
                },
                [_vm._v("\n        " + _vm._s(item.question) + "\n      ")]
              ),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }